export default {"src":"/_next/static/media/play.f4f80089.svg","height":24,"width":24};